'use strict'

// import { CookiePolicy } from './lib/CookiePolicy'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { Accordion } from './lib/Accordion'
import { MomentumScroll } from './lib/MomentumScroll'
import { HeaderSize } from './lib/HeaderSize'
import { EndlessSlider } from './lib/EndlessSlider'
import { FlexibleSlider } from './lib/flexibleSlider'
import { ContainerOver } from './lib/ContainerOver'
import { MyChoice } from './lib/MyChoice'
import { AdvancedDiploma } from './lib/AdvancedDiploma'
import { Footer } from './lib/Footer'
import { Loading } from './lib/Loading'
import { Navigation } from './lib/Navigation'
import { SplitText } from './lib/SplitText'
// new CookiePolicy('optout')
new Svg()
new TelGrant()
new Smooth()
new Drawer()
new ScrollStatus()
new ScrollAnimation()
new Accordion()
new MomentumScroll()
new HeaderSize()
new EndlessSlider()
new FlexibleSlider()
new ContainerOver()
new MyChoice()
new AdvancedDiploma()
new Footer()
new Loading()
new Navigation()
new SplitText()